import { Container, Heading, Section } from 'react-bulma-components';

import React from 'react';
//import networkError from "assets/images/networkerror.svg";
import IconNetworkError from './icons/IconNetworkError'

const NetworkError = () => {
return(
  <div>
    <Section>
        <Container>
          <p className="bd-notification is-success">
            <Heading size={5} renderAs="p">Network error</Heading>
            <Heading subtitle renderAs="p">Please check your Internet connection</Heading>
           <IconNetworkError/>
           {/*  <img
              src={networkError}
              style={{
                height: "auto",
                display: "block",
                margin: "auto",
                position: "relative"
              }}
            /> */}
          </p>
        </Container>
      </Section>
    </div>
);
}
export default NetworkError;